module.exports = __webpack_public_path__ + "static/media/3m_website_logo_coorg_gdca.a61c297b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/3m_website_logo_coorg_gdca.jpg
// module id = 53
// module chunks = 0